export function padZero(num: number) {
	return num.toString().padStart(2, "0");
}
